/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Signin_Resend_WaitInputs */

const en_signin_resend_wait = /** @type {(inputs: Signin_Resend_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resend in ${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "Resend in {seconds} s" |
*
* @param {Signin_Resend_WaitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_resend_wait = /** @type {((inputs: Signin_Resend_WaitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Resend_WaitInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_signin_resend_wait(inputs)
});